export const SET_ORGANIZATION_STATUSES = 'SET_ORGANIZATION_STATUSES';
export const SET_PRODUCT_TYPES = 'SET_PRODUCT_TYPES';
export const SET_PRODUCT_SUBTYPES = 'SET_PRODUCT_SUBTYPES';
export const SET_PRODUCT_SUBTYPES_LOADING = 'SET_PRODUCT_SUBTYPES_LOADING';
export const SET_ORGANIZATION_DOCUMENTS = 'SET_ORGANIZATION_DOCUMENTS';
export const SET_IDENTIFICATION_TYPES = 'SET_IDENTIFICATION_TYPES';
export const SET_EQUIPMENTS = 'SET_EQUIPMENTS';
export const SET_LANGUAGES = 'SET_LANGUAGES';
export const SET_STEP = 'SET_STEP';
export const SET_ADDRESS = 'SET_ADDRESS';
export const SET_PHONE_NUMBER = 'SET_PHONE_NUMBER';
export const SET_SKILLS = 'SET_SKILLS';
export const SET_MEMBER_EQUIPMENTS = 'SET_MEMBER_EQUIPMENTS';
export const SET_MEMBER_PROFILE = 'SET_MEMBER_PROFILE';
